// Generated by ReScript, PLEASE EDIT WITH CARE


var crossIcon = "https://dom-content-vault-prod-cdn-assets.porter.in/cross_icon_grey_a85a70f29a/cross_icon_grey_a85a70f29a.svg";

var discountTag = "https://dom-content-vault-prod-cdn-assets.porter.in/discount_tag_660d49611b/discount_tag_660d49611b.svg";

var etaClockIcon = "https://dom-content-vault-prod-cdn-assets.porter.in/eta_clock_icon_7c9439ceff/eta_clock_icon_7c9439ceff.svg";

var goodsType = "https://dom-content-vault-prod-cdn-assets.porter.in/goods_type_43a85b82b2/goods_type_43a85b82b2.svg";

var mapPin = "https://dom-content-vault-prod-cdn-assets.porter.in/map_pin_cc7d3d58de/map_pin_cc7d3d58de.svg";

var paymentCash = "https://dom-content-vault-prod-cdn-assets.porter.in/payment_cash_0eac7e125c/payment_cash_0eac7e125c.svg";

var porterGoldTag = "https://dom-content-vault-prod-cdn-assets.porter.in/porter_gold_tag_51e5c723a9/porter_gold_tag_51e5c723a9.svg";

var search = "https://dom-content-vault-prod-cdn-assets.porter.in/search_07259261cb/search_07259261cb.svg";

var whiteArrowDropDown = "https://dom-content-vault-prod-cdn-assets.porter.in/white_dropdown_arrow_fcc9864f90/white_dropdown_arrow_fcc9864f90.svg";

var dropPin = "https://dom-content-vault-prod-cdn-assets.porter.in/drop_address_e0335d60b3/drop_address_e0335d60b3.svg";

var fromInput = "https://dom-content-vault-prod-cdn-assets.porter.in/from_input_9224516e71/from_input_9224516e71.svg";

var locationTrackIcon = "https://dom-content-vault-prod-cdn-assets.porter.in/location_track_icon_b34f9626f0/location_track_icon_b34f9626f0.svg";

var offersIcon = "https://dom-content-vault-prod-cdn-assets.porter.in/offers_6774a8617a/offers_6774a8617a.svg";

var nameInput = "https://dom-content-vault-prod-cdn-assets.porter.in/name_input_f03f884446/name_input_f03f884446.svg";

var personalReq = "https://dom-content-vault-prod-cdn-assets.porter.in/personal_e2011b4ae4/personal_e2011b4ae4.svg";

var businessReq = "https://dom-content-vault-prod-cdn-assets.porter.in/business_e8cb8eaab3/business_e8cb8eaab3.svg";

var houseShiftReq = "https://dom-content-vault-prod-cdn-assets.porter.in/houseshift_59f30b9d43/houseshift_59f30b9d43.svg";

var downloadAppIcon = "https://dom-content-vault-prod-cdn-assets.porter.in/download_app_icon_0ce9beae0a/download_app_icon_0ce9beae0a.svg";

var defaultTruckIcon = "https://dom-content-vault-prod-cdn-assets.porter.in/default_truck_icon_v2_dfe20c523f/default_truck_icon_v2_dfe20c523f.svg";

var clearInputIcon = "https://dom-content-vault-prod-cdn-assets.porter.in/clear_input_cross_grey_8d880447b1/clear_input_cross_grey_8d880447b1.svg";

var clearCircularIcon = "https://dom-content-vault-prod-cdn-assets.porter.in/clear_input_cross_grey_8d880447b1/clear_input_cross_grey_8d880447b1.svg";

export {
  crossIcon ,
  discountTag ,
  etaClockIcon ,
  goodsType ,
  mapPin ,
  paymentCash ,
  porterGoldTag ,
  search ,
  whiteArrowDropDown ,
  dropPin ,
  fromInput ,
  locationTrackIcon ,
  offersIcon ,
  nameInput ,
  personalReq ,
  businessReq ,
  houseShiftReq ,
  downloadAppIcon ,
  defaultTruckIcon ,
  clearInputIcon ,
  clearCircularIcon ,
}
/* No side effect */
